import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledBackstageSelect = (
  _: Theme,
): BackstageOverrides['BackstageSelect'] => ({
  formControl: {
    margin: 'unset',
    maxWidth: 'unset',
  },
});
